// extracted by mini-css-extract-plugin
export default {"actionButtonStyle":"ChangePasswordCard_actionButtonStyle__2rU54","form":"ChangePasswordCard_form__gk4m+","gridContainer":"ChangePasswordCard_gridContainer__--8GC"};